import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class BreadcrumbsAdsDefault extends PureComponent {
  render() {
    const { name, } = this.props;

    return (
      <div className="main-area__header ads-breadcrumbs">
        <div className="details__menu">
          <ul>
            {name}
          </ul>
        </div>
      </div>
    );
  }
}

BreadcrumbsAdsDefault.propTypes = {
  name: PropTypes.string.isRequired,
};

export default BreadcrumbsAdsDefault;
